import React, {useState, useEffect, useContext} from "react";
import {ReactComponent as SeeIcon} from "../../../assets/icons/eye.svg";
import {HeadDropDown, BodyDropDown, RightHead} from "../../../styles/ContentViews";
import {ButtonWithIcon} from "../../../styles/Butttons";
import {AcademyContext} from "../../../context/AcademyProvider";
import ToogleForm from "../../../components/imagenEncabezado/ToogleForm";
import GetForm from "./GetForm";
import {UpdateDomecqAcademy} from "../../../services/GeneralServices";
import AppLoader from "../../../components/loaders/Loader";
import {PageWebUrl} from "../../../services/ApiUrl";

export default function EditAcademy({idUpdate, video, nameUpdate, title, type, hashUrl}) {
   const [currentData, setCurrentData] = useState({longDescription: ""});
   const [editable, setEditable] = useState(false);
   const {academyList, getList} = useContext(AcademyContext);
   const [isSaving, setSaving] = useState(false);

   useEffect(() => {
      getData();
   }, [academyList]);

   const getData = async () => {
      let filtered = academyList.find((item) => item.idDomecqAcademyContent === idUpdate);
      setCurrentData(filtered);
   };

   const save = (e) => {
      e.preventDefault();
      setSaving(true);
      let toSend = new FormData();

      toSend.append("idDomecqAcademyContent", currentData.idDomecqAcademyContent);
      toSend.append("token", localStorage.getItem("domecq_token"));
      toSend.append("title", currentData.title);
      toSend.append("description", e.target.longDescription.value.replace(/\n/g, "<br>"));
      if (video) {
         if (e.target[`video${nameUpdate}`].files[0]) {
            toSend.append("pathVideo", e.target[`video${nameUpdate}`].files[0]);
         }
      }
      if (e.target[`desk${nameUpdate}`].files[0]) {
         toSend.append("pathImageWebDesktop", e.target[`desk${nameUpdate}`].files[0]);
      }
      if (e.target[`mobile${nameUpdate}`].files[0]) {
         toSend.append("pathImageWebMobile", e.target[`desk${nameUpdate}`].files[0]);
      }
      UpdateDomecqAcademy(toSend)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setSaving(false);
         })
         .then(() => {
            getList(true);
         })
         .then(() => {
            setEditable(false);
         })
         .catch((e) => {
            setSaving(false);
         });
   };

   return (
      <>
         <HeadDropDown>
            <RightHead>
               {!editable && (
                  <ButtonWithIcon
                     Icon={SeeIcon}
                     text="Vista previa"
                     action={() => {
                        window.open(PageWebUrl + "domecq_academy/" + hashUrl, "_blank");
                     }}
                  />
               )}
            </RightHead>
         </HeadDropDown>
         <BodyDropDown>
            <GetForm
               data={currentData}
               change={() => {
                  setEditable(!editable);
               }}
               editable={editable}
               video={video}
               titleDesc={title}
               nameUpdate={nameUpdate}
               viewTitle={title}
               save={save}
            />
         </BodyDropDown>
         <AppLoader isVisible={isSaving} />
      </>
   );
}

EditAcademy.defaultProps = {
   hashUrl: "",
};
